/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const Search: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 8.39021 13.5947 9.68577 12.8959 10.775L15.5554 13.4345C16.1412 14.0203 16.1412 14.9701 15.5554 15.5558C14.9696 16.1416 14.0199 16.1416 13.4341 15.5558L10.7745 12.8962C9.68538 13.5949 8.39 14 7 14ZM7 12C9.76142 12 12 9.76142 12 7C12 4.23858 9.76142 2 7 2C4.23858 2 2 4.23858 2 7C2 9.76142 4.23858 12 7 12Z'
			/>
		</Svg>
	);
};

export { Search };
